import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { VendorsState } from "../../models/mp-common/vendors-state";

const initialState: VendorsState = {
	loading: true,
	allRetrieved: false
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.vendors.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.vendors.getSuccess, (state, action) => {
		const existing = _.cloneDeep(_.get(state, "vendor", []));
		const vendors = _.unionBy(action.vendors, existing, "id");
		return { vendors, loading: action.loading, allRetrieved: action.allRetrieved };
	}),
	on(MpAdminActions.vendors.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function AllVendorsReducer(state: VendorsState | undefined, action: Action): VendorsState {
	return reducer(state, action);
}
